import React from "react";
import { StatamicHtml, prefixStatamicAssetUrl } from "../../../utils/statamicAssets";

const TestimonialPanel = ({data}) => {

    const name = data.testimonial_name;
    const position = data.position;
    const copy = data.copy;
    const imageAsset = data.image;
    const image = imageAsset ? prefixStatamicAssetUrl(imageAsset.permalink || imageAsset.url) : null;
    const altText = imageAsset?.alt || 'Testimonial Image';
    let slideClass = "slide-content";

    if (!image) {
        slideClass += ' no-image';
    }

    return(
        <div className="slide">
            <div className={slideClass}>
                {image &&
                    <div className="image">
                        <img src={image} alt={altText} />
                    </div>
                }
                <div className="copy-wrapper">
                    <div className="copy-container">
                        <div className="name">{name}</div>
                        <div className="position">{position}</div>
                        {copy && <StatamicHtml className="copy" html={copy} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TestimonialPanel;
